import { create } from "zustand";
import { persist } from "zustand/middleware";
import { toast } from "react-hot-toast";
import { axiosInstance } from "../../lib/axiosInstance";
import useAuthStore from "../useAuthStore";

const useDashboardStore = create(
  persist(
    (set, get) => ({
      cardTile: null,
      projectTile: null,
      chartData: null,
      isLoading: false,

      // Fetch License Card Data
      getCardTile: async () => {
        set({ isLoading: true });

        const { token, user } = useAuthStore.getState();

        if (!token || !user || !user.id) {
          toast.error("Unauthorized: Login required or builder ID missing.");
          set({ isLoading: false });
          return;
        }

        try {
          const response = await axiosInstance.get(
            `/builders/dashboard/${user.id}/license`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          set({ cardTile: response.data });

        } catch (error) {
          console.error("Card Tile Fetch Error:", error);
          toast.error(error.response?.data?.message || "Failed to load card data");
        } finally {
          set({ isLoading: false });
        }
      },

      // Fetch Project Statistics
      getProjectTile: async () => {
        set({ isLoading: true });

        const { token, user } = useAuthStore.getState();

        if (!token || !user || !user.id) {
          toast.error("Unauthorized: Please log in or builder ID missing.");
          set({ isLoading: false });
          return;
        }

        try {
          const response = await axiosInstance.get(
            `/builders/dashboard/${user.id}/statistics`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          set({ projectTile: response.data });

        } catch (error) {
          console.error("Project Tile Fetch Error:", error);
          toast.error(error.response?.data?.message || "Failed to load project data");
        } finally {
          set({ isLoading: false });
        }
      },

      // Fetch Chart Data
      getChartData: async () => {
        set({ isLoading: true });

        const { token, user } = useAuthStore.getState();

        if (!token || !user || !user.id) {
          toast.error("Unauthorized: Please log in or builder ID missing.");
          set({ isLoading: false });
          return;
        }

        try {
          const response = await axiosInstance.get(
            `/builders/dashboard/${user.id}/charts`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          set({ chartData: response.data });

        } catch (error) {
          console.error("Chart Data Fetch Error:", error);
          toast.error(error.response?.data?.message || "Failed to load chart data");
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: "dashboard-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useDashboardStore;